<template>
  <div class="view" :style="{ height: fixedHeight + 'px' }" v-if="petMsg !== null">
    <!-- 宠物信息 -->
    <div class="pet">
      <el-image style="
          width: 58px;
          height: 58px;
          border-radius: 100%;
          margin-right: 20px;
        " :src="petMsg.cover" fit="cover" v-if="petMsg != null"></el-image>
      <div class="msg">
        <div class="comMsg" style="margin-top: 5px; margin-bottom: 12px">
          <div class="msgName">宠物信息:</div>
          <div class="msgContent">
            <div class="item">{{ petMsg.insideName }}</div>
            <div class="item">{{ petMsg.petSex }}</div>
            <div class="item">{{ petMsg.breedInfo.name }}</div>
            <div class="item">{{ petMsg.age }}</div>
            <div class="item" v-for="(item, index) in petMsg.customFeatures" :key="index">
              {{ item }}
            </div>
            <div class="item">
              {{ petMsg.petHair ? petMsg.petHair.title : "--" }}
            </div>
            <div class="item">
              {{ petMsg.sterilization == 0 ? "未绝育" : "已绝育" }}
            </div>
            <div class="item">{{ petMsg.weight }}kg</div>
            <div class="item">芯片号:{{ petMsg.epromNo }}</div>
            <div class="item">脖圈号:{{ petMsg.insideNo }}</div>
          </div>
        </div>
        <div class="comMsg">
          <div class="msgName">宠物状态:</div>
          <div class="msgContent" v-if="petMsg != null">
            <div class="item">{{ petMsg.status.title }}</div>
            <div class="item">{{ petMsg.petLevel.stars }}星</div>
            <div class="item">{{ petMsg.sale_price }}元</div>
            <div class="item">所在门店:{{ petMsg.feedShop.name }}</div>
            <div class="item" v-if="petMsg.status.value != '1'">
              售卖状态:{{ petMsg.status.title }}
            </div>
            <div class="item" v-else>
              售卖状态:{{ petMsg.saleStatus.title }}
            </div>
            <div class="item">疫苗:第{{ petMsg.vaccineNeedle }}针</div>
          </div>
        </div>
      </div>
      <div class="comRight">
        <el-button type="warning" size="small" @click="handleBackClick">返回</el-button>
        <div @click="tab = 9" v-if="$buttonAuthority('huoti-zongcang-editpet')">编辑</div>
      </div>
    </div>

    <!-- 内容 -->
    <div class="model">
      <div class="modelLeft">
        <div class="modelItem" @click="tab = 0" :style="{ 'border-color': tab == 0 ? '#F5882A' : '' }">
          <img src="../../assets/img/ht11.png" />
          <div :style="{ color: tab == 0 ? '#F5882A' : '' }">总任务</div>
          <img src="../../assets/img/ht16.png" v-if="tab != 0" />
          <img src="../../assets/img/ht17.png" v-if="tab == 0" />
        </div>
        <div class="modelItem" @click="tab = 1" :style="{ 'border-color': tab == 1 ? '#F5882A' : '' }">
          <img src="../../assets/img/ht12.png" />
          <div :style="{ color: tab == 1 ? '#F5882A' : '' }">转移记录</div>
          <img src="../../assets/img/ht16.png" v-if="tab != 1" />
          <img src="../../assets/img/ht17.png" v-if="tab == 1" />
        </div>
        <div class="modelItem" @click="tab = 2" :style="{ 'border-color': tab == 2 ? '#F5882A' : '' }">
          <img src="../../assets/img/ht13.png" />
          <div :style="{ color: tab == 2 ? '#F5882A' : '' }">疫苗记录</div>
          <img src="../../assets/img/ht16.png" v-if="tab != 2" />
          <img src="../../assets/img/ht17.png" v-if="tab == 2" />
        </div>
        <div class="modelItem" @click="tab = 3" :style="{ 'border-color': tab == 3 ? '#F5882A' : '' }">
          <img src="../../assets/img/ht14.png" />
          <div :style="{ color: tab == 3 ? '#F5882A' : '' }">亡故记录</div>
          <img src="../../assets/img/ht16.png" v-if="tab != 3" />
          <img src="../../assets/img/ht17.png" v-if="tab == 3" />
        </div>
        <div class="modelItem" @click="tab = 4" :style="{ 'border-color': tab == 4 ? '#F5882A' : '' }">
          <img src="../../assets/img/ht15.png" />
          <div :style="{ color: tab == 4 ? '#F5882A' : '' }">操作日志</div>
          <img src="../../assets/img/ht16.png" v-if="tab != 4" />
          <img src="../../assets/img/ht17.png" v-if="tab == 4" />
        </div>
        <div v-show="petMsg.takeStatus == 1" class="modelItem" @click="tab = 5"
          :style="{ 'border-color': tab == 5 ? '#F5882A' : '' }">
          <img src="../../assets/img/ht19.png" />
          <div :style="{ color: tab == 5 ? '#F5882A' : '' }">交宠照片</div>
          <img src="../../assets/img/ht16.png" v-if="tab != 5" />
          <img src="../../assets/img/ht17.png" v-if="tab == 5" />
        </div>
        <div v-show="petMsg.takeStatus == 1" class="modelItem" @click="tab = 6"
          :style="{ 'border-color': tab == 6 ? '#F5882A' : '' }">
          <img src="../../assets/img/ht18.png" />
          <div :style="{ color: tab == 6 ? '#F5882A' : '' }">宠物证书</div>
          <img src="../../assets/img/ht16.png" v-if="tab != 6" />
          <img src="../../assets/img/ht17.png" v-if="tab == 6" />
        </div>
        <div class="modelItem" @click="tab = 7" :style="{ 'border-color': tab == 7 ? '#F5882A' : '' }">
          <img src="../../assets/img/ht22.png" />
          <div :style="{ color: tab == 7 ? '#F5882A' : '' }">负责人</div>
          <img src="../../assets/img/ht16.png" v-if="tab != 7" />
          <img src="../../assets/img/ht17.png" v-if="tab == 7" />
        </div>
        <div class="modelItem" @click="tab = 8" :style="{ 'border-color': tab == 8 ? '#F5882A' : '' }">
          <img src="../../assets/img/ht20.png" />
          <div :style="{ color: tab == 8 ? '#F5882A' : '' }">质检</div>
          <img src="../../assets/img/ht16.png" v-if="tab != 8" />
          <img src="../../assets/img/ht17.png" v-if="tab == 8" />
        </div>
        <div class="modelItem" @click="tab = 10" :style="{ 'border-color': tab == 9 ? '#F5882A' : '' }">
          <img src="../../assets/img/ht21.png" />
          <div :style="{ color: tab == 10 ? '#F5882A' : '' }">宠物信息卡</div>
          <img src="../../assets/img/ht16.png" v-if="tab != 10" />
          <img src="../../assets/img/ht17.png" v-if="tab == 10" />
        </div>
      </div>
      <div class="modelRight" v-if="petMsg != null">
        <panelTask v-if="tab == 0" :id="id" :category="petMsg.categoryInfo._id"></panelTask>
        <panelTran v-if="tab == 1" :id="id"></panelTran>
        <panelVaccine v-if="tab == 2" :id="id"></panelVaccine>
        <panelDeath v-if="tab == 3" :id="id" @reset="getPetInfo"></panelDeath>
        <panelLog v-if="tab == 4" :id="id" :feedShop="feedShop"></panelLog>
        <!-- 照片 -->
        <panelPhoto v-if="tab == 5" :id="id" :pic="imgPic"></panelPhoto>
        <!-- 证书 -->
        <panelBook v-if="tab == 6" :id="id" :certificateImage="certificateImage"
          :buyPetMemberRealName="buyPetMemberRealName" :buyPetMemberIdNO="buyPetMemberIdNO" :petMsg="petBook">
        </panelBook>
        <!-- 负责人 -->
        <petManager v-if="tab == 7" :id="id"></petManager>
        <panelCheckInfo v-if="tab == 8" :tab="tab" :checkInfo="petMsg.checkInfo"></panelCheckInfo>
        <!-- 编辑宠物 -->
        <panelAddPet v-if="tab == 9" :tab="tab" :id="petMsg._id" @reset="getPetInfo"></panelAddPet>
         <!-- 宠物信息卡 -->
         <panelPetCart v-if="tab == 10" :tab="tab" :id="petMsg._id"></panelPetCart>
      </div>
    </div>
  </div>
</template>

<script>
import { getPetInfo } from "@/api/purchaseApi.js";
import panelAddPet from "./panel/panel_addPet.vue";
import petManager from "./panel/panel_petManager";
import panelDeath from "./panelDetail/panel_death.vue";
import panelLog from "./panelDetail/panel_log.vue";
import panelTran from "./panelDetail/panel_tran.vue";
import panelVaccine from "./panelDetail/panel_vaccine.vue";
import panelTask from "./panelDetail/panel_task.vue";
import panelPhoto from "./panelDetail/panel_photo.vue";
import panelBook from "./panelDetail/panel_book.vue";
import panelCheckInfo from "./panelDetail/panel_checkInfo.vue";
import panelPetCart from "./panelDetail/panel_cart.vue";

export default {
  components: {
    panelAddPet,
    panelDeath,
    panelLog,
    panelVaccine,
    panelTran,
    panelTask,
    panelPhoto,
    panelBook,
    petManager,
    panelCheckInfo,
    panelPetCart
  },
  data() {
    return {
      // 交宠照片
      imgPic: "",
      id: this.$route.query.id,
      fixedHeight: "", //模型高度
      //宠物信息
      petMsg: null,
      tab: 0, //tab切换
      petBook: "", //证书
      // 身份证号 证书照片 名字
      buyPetMemberIdNO: "",
      certificateImage: "",
      buyPetMemberRealName: "",
      feedShop: null,
    };
  },
  created() {
    this.fixedHeight = document.documentElement.clientHeight - 106;
  },
  mounted() {
    console.log("宠物id", this.id);
    this.getPetInfo();
  },
  methods: {
    formatChu(a) {
      if (a < 12) {
        return a + "个月";
      }
      if (a == 12) {
        return "1岁";
      } else {
        var n1 = Math.floor(a / 12);
        var n2 = a % 12;
        console.log(a, n1, n2);
        return n1 + "岁" + n2 + "个月";
      }
    },
    //返回按钮
    handleBackClick() {
      this.$router.back();
    },
    //获取宠物信息
    getPetInfo() {
      let params = {
        petId: this.id,
      };
      getPetInfo(params).then((res) => {
        if (res.code == 0) {
          console.log("宠物详情信息", res.data);
          this.petMsg = res.data;
          // 身份证号 证书照片 名字
          this.buyPetMemberIdNO = res.data.buyPetMemberIdNO;
          this.certificateImage = res.data.certificateImage;
          this.buyPetMemberRealName = res.data.buyPetMemberRealName;
          this.feedShop = res.data.feedShop;
          // 交宠照片
          this.imgPic = res.data.buyPetMemberPic || "";
          // console.log('交宠照片123',this.imgPic);
          this.petBook = res.data;
          console.log("证书", this.petBook);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.view {
  min-height: 852px;
  margin-top: 6px;
  font-family: PingFangSC-Regular, PingFang SC;
  margin-left: 4px;
  display: flex;
  flex-direction: column;

  // 头部信息
  .pet {
    display: flex;
    padding: 10px;
    max-height: 62px;
    border-radius: 4px;
    background: #fff;

    .msg {
      flex: 1;

      .comMsg {
        display: flex;
        align-items: center;
        line-height: 20px;
        font-size: 14px;

        .msgName {
          color: #333;
        }

        .msgContent {
          display: flex;
          align-items: center;
          color: #666;

          .item {
            padding: 0 8px;
            border-right: solid 1px #f2f2f2;
          }

          .item:nth-last-child(1) {
            border: none;
          }
        }
      }
    }

    .comRight {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      font-size: 14px;
      color: #f5882a;
      text-align: center;
    }
  }

  // 内容
  .model {
    display: flex;
    flex: 1;

    .modelLeft {
      width: 251px;
      margin-right: 12px;
      margin-top: 12px;

      .modelItem {
        padding: 12px 16px 12px 11px;
        background: #fff;
        margin-bottom: 12px;
        border-radius: 12px;
        border: 1px solid rgba(151, 151, 151, 0.13);
        box-sizing: border-box;
        display: flex;
        align-items: center;
        font-size: 12px;

        img:nth-of-type(1) {
          width: 40px;
          height: 40px;
          border-radius: 100%;
          margin-right: 12px;
        }

        img:nth-of-type(2) {
          width: 32px;
          height: 32px;
        }

        div {
          flex: 1;
        }
      }
    }

    .modelRight {
      flex: 1;
      // background: blue;
    }
  }
}
</style>
